var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vuetify-wrapper v-application" },
    [
      _c(
        "v-row",
        {
          staticClass: "vuetify-wrapper v-application",
          attrs: { "no-gutters": "" },
        },
        [
          _c(
            "v-col",
            { attrs: { cols: "auto" } },
            [
              _c("v-breadcrumbs", {
                staticClass: "pl-0",
                attrs: { items: _vm.breadcrumbItems },
                scopedSlots: _vm._u([
                  {
                    key: "divider",
                    fn: function () {
                      return [_c("v-icon", [_vm._v("mdi-chevron-right")])]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "d-flex align-center ml-auto",
              attrs: { cols: "auto" },
            },
            [
              _vm.pharmacy.sepa_auth
                ? _c(
                    "v-btn",
                    {
                      staticClass: "mr-2",
                      attrs: {
                        href: `/pharmacies/${_vm.pharmacy._id}/sepa_download`,
                        target: "_blank",
                        text: "",
                        outlined: "",
                        tile: "",
                        small: "",
                      },
                    },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "mr-1", attrs: { small: "" } },
                        [_vm._v("mdi-download")]
                      ),
                      _vm._v(" SEPA-Mandat\n            "),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-menu",
                {
                  attrs: { "offset-y": "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function ({ on, attrs }) {
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              _vm._b(
                                {
                                  staticClass: "select-password-mail",
                                  attrs: { small: "" },
                                },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [
                              _vm._v(
                                "\n                        Passwort-Mail\n                        "
                              ),
                              _c(
                                "v-icon",
                                { staticClass: "ml-1", attrs: { small: "" } },
                                [_vm._v("mdi-menu-down")]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _vm._v(" "),
                  _c(
                    "v-list",
                    [
                      _c(
                        "v-list-item",
                        {
                          attrs: { link: "" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.openMailDialog(
                                "mail_pw_existing_customer"
                              )
                            },
                          },
                        },
                        [
                          _c("v-list-item-title", [
                            _vm._v(
                              "\n                            Passwort Bestandskunde\n                        "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item",
                        {
                          attrs: { link: "" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.openMailDialog("mail_pw_reset")
                            },
                          },
                        },
                        [
                          _c("v-list-item-title", [
                            _vm._v(
                              "\n                            Passwort Reset\n                        "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item",
                        {
                          attrs: { link: "" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.openMailDialog("mail_pw_new_customer")
                            },
                          },
                        },
                        [
                          _c("v-list-item-title", [
                            _vm._v(
                              "\n                            Passwort Neu-Kunde\n                        "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("password-mail-dialog", {
                    attrs: {
                      mailTemplate: _vm.mailTemplate,
                      pharmacyEmailAddress: _vm.pharmacy.email,
                      pharmacyId: _vm.pharmacy._id,
                    },
                    model: {
                      value: _vm.isPasswordMailDialogOpen,
                      callback: function ($$v) {
                        _vm.isPasswordMailDialogOpen = $$v
                      },
                      expression: "isPasswordMailDialogOpen",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "cyan lighten-3 ml-2 edit-pharmacy",
                  attrs: {
                    href: `/pharmacies/${_vm.pharmacy._id}/edit`,
                    dark: "",
                    small: "",
                  },
                },
                [
                  _c("v-icon", { attrs: { small: "" } }, [
                    _vm._v("mdi-pencil"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        {
          staticClass: "v-application v-application--is-ltr",
          attrs: { "no-gutters": "" },
        },
        [
          _c(
            "v-col",
            { staticClass: "d-flex", attrs: { cols: "auto" } },
            [
              _c("h2", [_vm._v(_vm._s(_vm.pharmacy.name_or_owner))]),
              _vm._v(" "),
              _c(
                "v-chip-group",
                { staticClass: "ml-2" },
                [
                  _vm.pharmacy.sepa_auth
                    ? _c(
                        "v-chip",
                        {
                          staticClass: "sepa-mandate-label",
                          attrs: {
                            color: "error darken-2",
                            "x-small": "",
                            label: "",
                          },
                        },
                        [
                          _vm._v(
                            "\n                    SEPA Mandat\n                "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-chip", { attrs: { "x-small": "", label: "" } }, [
                    _vm.pharmacy.small_city
                      ? _c("span", [_vm._v("Kleinstadt")])
                      : _vm.pharmacy.small_city === false
                      ? _c("span", [_vm._v("Großstadt")])
                      : _c("span", [_vm._v("Unbekannte Stadtgröße")]),
                  ]),
                  _vm._v(" "),
                  _vm.pharmacy.no_approval_required
                    ? _c(
                        "v-chip",
                        {
                          staticClass: "no-approval-required-label",
                          attrs: { color: "success", "x-small": "", label: "" },
                        },
                        [
                          _vm._v(
                            "\n                    direkte Zusage\n                "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.pharmacy.acquisition
                    ? _c(
                        "v-chip",
                        { attrs: { color: "info", "x-small": "", label: "" } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.pharmacy.acquisition) +
                              "\n                "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.pharmacy.steffi_summary &&
                  _vm.pharmacy.steffi_summary.has_steffi_current_or_history
                    ? _c(
                        "v-chip",
                        {
                          staticClass: "steffi-profile-label",
                          attrs: {
                            color: _vm.pharmacy.steffi_summary.color,
                            "x-small": "",
                            label: "",
                            "text-color": "white",
                          },
                        },
                        [
                          _c(
                            "v-icon",
                            { staticClass: "mr-1", attrs: { "x-small": "" } },
                            [_vm._v("mdi-robot-outline")]
                          ),
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.pharmacy.steffi_summary.label) +
                              "\n                "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.tabNumber === 1
            ? _c(
                "v-col",
                { staticClass: "d-flex ml-auto", attrs: { cols: "auto" } },
                [
                  _c("appointment-creator", {
                    attrs: { pharmacy: _vm.pharmacy },
                    on: {
                      "fetch-appointments": function ($event) {
                        return _vm.$refs.appointments.fetchAppointmentsCounts()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "add-appointments ml-3",
                      attrs: {
                        href: `/pharmacies/${_vm.pharmacy._id}/add_appointments`,
                        small: "",
                      },
                    },
                    [
                      _c("v-icon", { attrs: { small: "" } }, [
                        _vm._v("mdi-plus"),
                      ]),
                      _vm._v(" mehrere Termine anlegen\n            "),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("v-col", { staticClass: "mt-1", attrs: { cols: "12" } }, [
            _vm.pharmacy.user_id
              ? _c(
                  "span",
                  { staticClass: "mr-3" },
                  [
                    _c("b", [_vm._v("Benutzer:")]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "username",
                        attrs: {
                          href: `/pharmacies/users/${_vm.pharmacy.user_id}`,
                          target: "_blank",
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.pharmacy.user.firstname) +
                            " " +
                            _vm._s(_vm.pharmacy.user.lastname) +
                            "\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.pharmacy.user.terms_confirmed
                      ? _c(
                          "v-chip",
                          {
                            staticClass: "px-1",
                            attrs: { "x-small": "", outlined: "" },
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                staticClass: "mr-1",
                                attrs: { "x-small": "", color: "success" },
                              },
                              [_vm._v("mdi-check")]
                            ),
                            _vm._v(
                              "\n                    AGBs\n                "
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.pharmacy.user.dataprotection_confirmed
                      ? _c(
                          "v-chip",
                          {
                            staticClass: "px-1",
                            attrs: { "x-small": "", outlined: "" },
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                staticClass: "mr-1",
                                attrs: { "x-small": "", color: "success" },
                              },
                              [_vm._v("mdi-check")]
                            ),
                            _vm._v(
                              "\n                    DSGVO\n                "
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.pharmacy.customer_id
              ? _c("span", { staticClass: "mr-3" }, [
                  _c("b", [_vm._v("Kundennummer:")]),
                  _vm._v(
                    " " + _vm._s(_vm.pharmacy.customer_id) + "\n            "
                  ),
                ])
              : _c(
                  "span",
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "mr-3 set-customer-id",
                        attrs: { small: "" },
                        on: {
                          click: function ($event) {
                            _vm.isConfirmationDialogOpen = true
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    Kundennummer vergeben\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("confirmation-dialog", {
                      attrs: { message: "Bist Du sicher?" },
                      on: { save: _vm.generateCustomerId },
                      model: {
                        value: _vm.isConfirmationDialogOpen,
                        callback: function ($$v) {
                          _vm.isConfirmationDialogOpen = $$v
                        },
                        expression: "isConfirmationDialogOpen",
                      },
                    }),
                  ],
                  1
                ),
            _vm._v(" "),
            _c("span", { staticClass: "mr-3" }, [
              _c("b", [_vm._v("BtM-Nummer:")]),
              _vm._v(" "),
              _vm.pharmacy.btm
                ? _c("span", [_vm._v(_vm._s(_vm.pharmacy.btm))])
                : _c("span", [_vm._v("Nein")]),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "mr-3" }, [
              _c("b", [_vm._v("Erstellt:")]),
              _vm._v(" "),
              _vm.pharmacy.created_by
                ? _c(
                    "a",
                    {
                      attrs: {
                        href: `/pharmacies/users/${_vm.pharmacy.created_by}`,
                        target: "_blank",
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$formatDate(_vm.pharmacy.created)) +
                          "\n                "
                      ),
                    ]
                  )
                : _c("span", [
                    _vm._v(_vm._s(_vm.$formatDate(_vm.pharmacy.created))),
                  ]),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "mr-3" }, [
              _c("b", [_vm._v("Bearbeitet:")]),
              _vm._v(" "),
              _vm.pharmacy.updated_by
                ? _c(
                    "a",
                    {
                      attrs: {
                        href: `/pharmacies/users/${_vm.pharmacy.updated_by}`,
                        target: "_blank",
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$formatDate(_vm.pharmacy.updated)) +
                          "\n                "
                      ),
                    ]
                  )
                : _c("span", [
                    _vm._v(_vm._s(_vm.$formatDate(_vm.pharmacy.updated))),
                  ]),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.pharmacy.branches && _vm.pharmacy.branches.length > 1
        ? _c(
            "v-row",
            {
              staticClass: "v-application v-application--is-ltr",
              attrs: { "no-gutters": "" },
            },
            [
              _c(
                "v-col",
                [
                  _c("strong", [_vm._v("Filialen:")]),
                  _vm._v(" "),
                  _vm._l(_vm.pharmacy.branches, function (branch, index) {
                    return _c("span", { key: branch._id }, [
                      branch._id === _vm.pharmacy._id
                        ? _c("strong", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(branch.shortname) +
                                " (" +
                                _vm._s(branch.customer_id) +
                                ")\n                "
                            ),
                          ])
                        : _c(
                            "a",
                            {
                              staticClass: "text-decoration-none",
                              attrs: {
                                href: `/pharmacies/${branch._id}`,
                                target: "_blank",
                                rel: "noopener noreferrer",
                              },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(branch.shortname) +
                                  " (" +
                                  _vm._s(branch.customer_id) +
                                  ")\n                "
                              ),
                            ]
                          ),
                      _vm._v(" "),
                      index < _vm.pharmacy.branches.length - 1
                        ? _c("span", [_vm._v(", ")])
                        : _vm._e(),
                    ])
                  }),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "v-application" },
        [
          _c(
            "v-col",
            { staticClass: "mb-4" },
            [
              _c("pharmacy-info", {
                attrs: {
                  pharmacy: _vm.pharmacy,
                  knownPharmacists: _vm.pharmacists,
                },
                on: { "get-pharmacy": _vm.getPharmacy },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tabs",
        {
          attrs: { "center-active": "", "active-class": "", "show-arrows": "" },
          model: {
            value: _vm.tabNumber,
            callback: function ($$v) {
              _vm.tabNumber = $$v
            },
            expression: "tabNumber",
          },
        },
        _vm._l(_vm.tabs, function (tab) {
          return _c(
            "v-tab",
            { key: tab.value, attrs: { id: `${tab.value}-tab` } },
            [_vm._v("\n            " + _vm._s(tab.text) + "\n        ")]
          )
        }),
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c(
        "v-tabs-items",
        {
          staticClass: "tab-items-container",
          model: {
            value: _vm.tabNumber,
            callback: function ($$v) {
              _vm.tabNumber = $$v
            },
            expression: "tabNumber",
          },
        },
        [
          _c(
            "v-tab-item",
            [
              _c("pharmacists-info", {
                attrs: { pharmacists: _vm.pharmacists, pharmacy: _vm.pharmacy },
                on: {
                  "get-pharmacists": function ($event) {
                    _vm.getPharmacists()
                    _vm.getPharmacy()
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab-item",
            [
              _c("appointments-overview", {
                ref: "appointments",
                attrs: { pharmacy_id: _vm.pharmacyId },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab-item",
            [_c("ticket-overview", { attrs: { pharmacy_id: _vm.pharmacyId } })],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab-item",
            [
              _c("linked-discounts", {
                attrs: {
                  pharmacyId: _vm.pharmacy._id,
                  appliedDiscounts: _vm.pharmacy.applied_discounts,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab-item",
            [
              _c("pharmacy-call-history-table", {
                ref: "call-history",
                attrs: {
                  pharmacyId: _vm.pharmacy._id,
                  phone: _vm.pharmacy.phone,
                  mobile: _vm.pharmacy.mobile,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab-item",
            [
              _c("steffi-profile-tab", {
                attrs: { pharmacyId: _vm.pharmacyId },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab-item",
            [
              _c("custom-invoices", {
                attrs: {
                  "recipient-type": "pharmacy",
                  "recipient-id": _vm.pharmacyId,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }